import React,{useState} from 'react';
import { Rating } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
  
const Container = styled.div`
display:flex;`;

const labels = {
    0.5: 'Muy deficiente',
    1: 'Por debajo de lo esperado',
    1.5: 'Necesita mejora',
    2: 'Deficiente',
    2.5: 'Regular',
    3: 'Satisfactorio',
    3.5: 'Bueno',
    4: 'Muy bueno',
    4.5: 'Excelente',
    5: 'Excepcional',
};

const Reseña = ({step,title,setValue,Value}) =>
{
    return <div>
        <p>{step}. {title}</p>
        <Container>
            <Rating  value={Value}  onChange={(event, newHover) => {setValue(newHover)}}/>
            {Value !== null && <p>{labels[Value]}</p>}
        </Container>
    </div> 
}

export default Reseña;